import {OVERLAY_IDS} from 'modules/overlay/constants'

import {CheckoutOfferContext} from '@vio/core/src/analytics/types/Events'

export const OVERLAY_SHOW = 'OVERLAY_SHOW'
export const OVERLAY_HIDE = 'OVERLAY_HIDE'
export const OVERLAY_STACK_REPLACE = 'OVERLAY_STACK_REPLACE'
export const OVERLAY_SYNC_TO_URL = 'OVERLAY_SYNC_TO_URL'

type ShowOverlayId = string
type ShowOverlayExtraState = Record<string, unknown> | null | undefined

export interface ShowOverlayParams {
  id: ShowOverlayId
  extraState: ShowOverlayExtraState
}

export const showOverlay = (
  id: ShowOverlayId,
  extraState?: ShowOverlayExtraState,
  ignoreHistory?: boolean
) => ({
  type: OVERLAY_SHOW,
  params: {id, extraState},
  ignoreHistory
})

type HideOverlayId = string

export interface HideOverlayParams {
  id: HideOverlayId
}

export const hideOverlay = (
  id: HideOverlayId,
  ignoreHistory: boolean,
  offerEventContext?: CheckoutOfferContext
) => ({
  type: OVERLAY_HIDE,
  params: {id, offerEventContext},
  ignoreHistory
})

type ReplaceOverlays = {
  id: string
  extraState?: Record<string, unknown> | null
}[]

export interface ReplaceOverlaysParams {
  overlays: ReplaceOverlays
}

export const replaceOverlayStack = (overlays: ReplaceOverlays) => ({
  type: OVERLAY_STACK_REPLACE,
  params: {overlays}
})

export interface SyncOverlayToUrlParams {
  targetId: string | null
}

export const syncOverlayToUrl = (targetId: string | null) => ({
  type: OVERLAY_SYNC_TO_URL,
  params: {targetId}
})

export interface ReplaceOverlayTopParams {
  id: string
  extraState: Record<string, unknown> | null
}

export type ModuleActionType =
  | ReturnType<typeof showOverlay>
  | ReturnType<typeof hideOverlay>
  | ReturnType<typeof replaceOverlayStack>
  | ReturnType<typeof syncOverlayToUrl>

const changeOverlayVisibility =
  (id: string) =>
  (willBecomeVisible: boolean, ignoreHistory = false) =>
  (extraState?: Record<string, unknown>) => {
    if (!willBecomeVisible) {
      return hideOverlay(id, ignoreHistory)
    }

    return showOverlay(id, extraState, ignoreHistory)
  }

export const changePreferencesVisibility = changeOverlayVisibility(
  OVERLAY_IDS.preferences
)
export const changeRoomDetailsVisibility = changeOverlayVisibility(
  OVERLAY_IDS.roomDetails
)
export const changeHotelGalleryVisibility = changeOverlayVisibility(
  OVERLAY_IDS.hotelGallery
)
export default showOverlay
